<page-load-header *ngIf="!initialized"></page-load-header>

<div *ngIf="initialized">
  <div class="header pb-6">
    <div>
      <div class="header-body">
        <div class="row align-items-center py-4">
          <div class="col-12">
            <h6 class="h2 d-inline-block mb-0">Gait Report</h6>
          </div>
          <div class="col-12">
            <a href="javascript:void(0)" [routerLink]="[listURL]"> &#60; Back to all Assessments</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt--6">
    <gait-analysis-walking-result-details [isCoachView]="true"></gait-analysis-walking-result-details>
  </div>
</div>
